import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { deleteApiKeySaga } from '@/store/apiKeys/apiKeysSlice'
import { selectIsLoading } from '@/store/ui/uiSelectors'
import type { ApiKey } from '@/store/apiKeys/apiKeysSlice'
import { useWorkspace } from '@/contexts/WorkspaceContext'
import { TextMidd, TextSmall } from '@/components/ui/Text'
import IconButton from '@/components/ui/IconButton/IconButton'
import IconTrash from '@/assets/icons/icon-trash.svg?react'
import css from './ApiKeyRow.module.css'

interface ApiKeyRowProps {
    apiKey: ApiKey
}

const formatDate = (iso: string) =>
    new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })

const ApiKeyRow = ({ apiKey }: ApiKeyRowProps) => {
    const dispatch = useAppDispatch()
    const { workspace } = useWorkspace()
    const isDeleting = useAppSelector(selectIsLoading(`delete-api-key-${apiKey.id}`))

    const handleDelete = () => {
        if (!workspace?.id) return
        dispatch(deleteApiKeySaga({ id: apiKey.id, workspaceId: workspace.id }))
    }

    return (
        <div className={css.row}>
            <div className={css.info}>
                <TextMidd>{apiKey.name}</TextMidd>
                <TextSmall className={css.meta}>
                    {apiKey.keyPrefix}
                    {apiKey.lastUsedAt ? ` · Last used ${formatDate(apiKey.lastUsedAt)}` : ' · Never used'}
                </TextSmall>
            </div>
            <IconButton icon={<IconTrash />} onClick={handleDelete} disabled={isDeleting} />
        </div>
    )
}

export default ApiKeyRow
